import {
    get,
    post,
    uploadFile,
    downloadFile,
    downloadPdfFile,
    downloadPickOrderFile,
    downloadProxyDeliverFile,
} from 'Utils/apiUtil';
import {callApi} from 'Utils/apiUtil';
import {
    hostOrderListUrl,
    completedOrderListUrl,
    hostShipmentListUrl,
    punchSaveUrl,
    punchReceivableUrl,
    feedbackSaveUrl,
    feedbackListUrl,
    myOrderDetailUrl,
    hostDeliverToShipUrl,
    hostShipmentDetailUrl,
    shipmentShipUrl,
    shipmentHoldOrderUrl,
    cancelOrderUrl,
    receiveShipmentUrl,
    updateShipmentUrl,
    updateOtherImagesUrl,
    deleteShipmentAttachmentUrl,
    checkOrderStatusUrl,
    cancelPackageUrl,
    f1OrderListUrl,
    f1OrderDetailsUrl,
    f1OrderReceiveUrl,
    uploadFileUrl,
    createInvoicePdfUrl,
    printDispatchPdfsUrl,
    abnormalRecordListUrl,
    saveAbnormalRecordUrl,
    getSkuReplenishmentDetailsUrl,
    getAllSkuConditionUrl,
    getSKUInventoryDetailUrl,
    createRecommendPdfUrl,
    shipmentWaitOrderUrl,
    shipmentUpdateTrackNumberUrl,
    f1ShipmentViewUrl,
    f1ShipmentWaitReceivelUrl,
    f1ShipmentWaitShipUrl,
    f1ShipmentReceivedUrl,
    f1ShipmentReceiveUrl,
    userCenterAdventQuantityUrl,
    adventProductOfSCListUrl,
    addAdventInventorDetailUrl,
    tagUploadUrl,
    previewTagUploadUrl,
    deliverDetailUrl,
    shipmentPackageQuantityUrl,
    scrapUploadUrl,
    supplyCenterListUrl,
    skuVagueSearch,
    internalOrderQueryUrl,
    internalAddOrderNoUrl,
    internalOrderQueryKitUrl,
    internalOrderTransferApplyUrl,
    getInternalOrderScHostAddressUrl,
    internalWithdrawUrl,
    internalUpdatedOrderNoUrl,
    internalReceivedGoodUrl,
    getSkuKitListOfInternalOrderUrl,
    getLotQuantityOfInternalOrderUrl,
    internalOrderDetailUrl,
    updateShipStatusUrl,
    internalRedQuantityUrl,
    getAllSCListUrl,
    getOrderDetailMessageCountUrl,
    getOrderDetailMessageListUrl,
    getOrderDetailOneKeyReadUrl,
    getYourMsgTotalUrl,
    getYourMsgListUrl,
    signReadUrl,
    f1OrderListRefreshUrl,
    getScrapTypeUrl,
    checkF1NumberUrl,
    e1GetSkuListUrl,
    getScrapParamsUrl,
    queryPickOrderListUrl,
    cancelPickOrderUrl,
    savePickOrderUrl,
    shipOrderUrl,
    forceCancelUrl,
    batchRecommendPdfsUrl,
    pickOrderPreviewPdfsUrl,
    messageOneKeyReadUrl,
    getPickOrderMessageUrl,
    getF1PackageOnTheGoListUrl,
    viewOnTheGoPackageUrl,
    viewOrderTrackingUrl,
    gaoMapCurrentLocationUrl,
    b2bCasmartShipmentUrl,
    getF1MessageListUrl,
    getReceiveCodeUrl,
    shipmentDocumentCoaUrl,
    shipmentProxyPdfUrl,
    shipmentNotificationSendUrl,
    shipmentNotificationCheckUrl,
    sysDictUrl,
} from 'Utils/urlUtil';

export const SHIPMENTLIST = 'SHIPMENTLIST';
export const SHIPMENTORORDERDETAILS = 'SHIPMENTORORDERDETAILS';
export const F1ORDERLIST = 'F1ORDERLIST';
export const F1_PACKAGE_ON_THE_GO_ORDERLIST = 'F1_PACKAGE_ON_THE_GO_ORDERLIST';
export const VIEW_ORDER_TRACKING = 'VIEW_ORDER_TRACKING';
export const F1ORDERSEARCHLIST = 'F1ORDERSEARCHLIST';
export const F1ORDERDETAILS = 'F1ORDERDETAILS';
export const ABNORMALRECORDLIST = 'ABNORMALRECORDLIST';
export const SKU_REPLENISHMENT_DETAILS = 'SKU_REPLENISHMENT_DETAILS';
export const SKU_INVENTORY_DETAILS = 'SKU_INVENTORY_DETAILS';
export const F1ORDER_SEARCH_FIELD = 'F1ORDER_SEARCH_FIELD';
export const SHIPMENT_SEARCH_FIELD = 'SHIPMENT_SEARCH_FIELD';
export const UPDATEF1ORDERSEARCHLIST = 'UPDATEF1ORDERSEARCHLIST';
export const F1ORDER_RECEIVE_SEARCH_FIELD = 'F1ORDER_RECEIVE_SEARCH_FIELD';
export const SAVE_F1ORDER_RECEIVE_ORDER = 'SAVE_F1ORDER_RECEIVE_ORDER';
export const F1ORDER_RECEIVE_DETAIL = 'F1ORDER_RECEIVE_DETAIL';
export const F1_SHIPMENT_VIEW_DATA = 'F1_SHIPMENT_VIEW_DATA';
export const F1_SHIPMENT_WAIT_RECEIVE = 'F1_SHIPMENT_WAIT_RECEIVE';
export const F1_SHIPMENT_WAIT_SHIP = 'F1_SHIPMENT_WAIT_SHIP';
export const F1_SHIPMENT_RECEIVED = 'F1_SHIPMENT_RECEIVED';
export const F1_ORDERLIST_SEARCH_FIELD = 'F1_ORDERLIST_SEARCH_FIELD';

export const GET_USER_CENTER_ADVENT_QUANTITY =
    'GET_USER_CENTER_ADVENT_QUANTITY';
export const GET_ADVENT_PRODUCT_SC_LIST = 'GET_ADVENT_PRODUCT_SC_LIST';
export const ADD_ADVENT_INVENTORY_DETAIL = 'ADD_ADVENT_INVENTORY_DETAIL';
export const ADVENT_PRODUCT_TAG_UPLOAD = 'ADVENT_PRODUCT_TAG_UPLOAD';
export const PREVIEW_ADVENT_IMAGE = 'PREVIEW_ADVENT_IMAGE';
export const GET_DELIVER_DETAILS = 'GET_DELIVER_DETAILS';
export const GET_SHIPPED_PACKAGE_QUANTITY = 'GET_SHIPPED_PACKAGE_QUANTITY';
export const SCRAP_UPLOAD = 'SCRAP_UPLOAD';
export const SUPPLY_CENTER = 'SUPPLY_CENTER';
export const SKU_VAGUE_SEARCH = 'SKU_VAGUE_SEARCH';
export const GET_INTERNAL_ORDER_LIST = 'GET_INTERNAL_ORDER_LIST';
export const GET_INTERNAL_ORDER_KIT_LIST = 'GET_INTERNAL_ORDER_KIT_LIST';
export const GET_INTERNAL_ORDER_SC_HOST_ADDRESS =
    'GET_INTERNAL_ORDER_SC_HOST_ADDRESS';
export const INTERNAL_ADD_ORDER_NO = 'INTERNAL_ADD_ORDER_NO';
export const INTERNAL_WITHDRAW = 'INTERNAL_WITHDRAW';
export const INTERNAL_UPDATE_NO = 'INTERNAL_UPDATE_NO';
export const INTERNAL_RECEIVED_GOOD = 'INTERNAL_RECEIVED_GOOD';
export const INTERNAL_TRANSFER_SEARCH_FIELD = 'INTERNAL_TRANSFER_SEARCH_FIELD';
export const GET_SKU_KIT_LIST_OF_INTERNAL_ORDER =
    'GET_SKU_KIT_LIST_OF_INTERNAL_ORDER';
export const GET_LOT_QUANTITY_OF_INTERNAL_ORDER =
    'GET_LOT_QUANTITY_OF_INTERNAL_ORDER';
export const GET_INTERNAL_ORDER_DETAIL = 'GET_INTERNAL_ORDER_DETAIL';
export const UPDAE_INTERNAL_ORDER_STATUS = 'UPDAE_INTERNAL_ORDER_STATUS';
export const INTERNAL_REDQUANTITY = 'INTERNAL_REDQUANTITY';
export const ALL_SC_LIST = 'ALL_SC_LIST';
export const ORDER_DETAIL_MESSAGE_COUNT = 'ORDER_DETAIL_MESSAGE_COUNT';
export const ORDER_DETAIL_MESSAGE_LIST = 'ORDER_DETAIL_MESSAGE_LIST';
export const ORDER_DETAIL_ON_KEY_READ = 'ORDER_DETAIL_ON_KEY_READ';
export const YOUR_MESSAGE_TOTAL = 'YOUR_MESSAGE_TOTAL';
export const YOUR_MESSAGE_LIST = 'YOUR_MESSAGE_LIST';
export const YOUR_MESSAGE_READ = 'YOUR_MESSAGE_READ';
export const F1_ORDER_LIST_REFRESH = 'F1_ORDER_LIST_REFRESH';
export const GET_SCRAP_TYPE = 'GET_SCRAP_TYPE';
export const CHECK_F1_NUMBER = 'CHECK_F1_NUMBER';
export const E1_GET_SKU_LIST = 'E1_GET_SKU_LIST';
export const GET_SCRAP_PARAMS = 'GET_SCRAP_PARAMS';
export const GET_FEED_BACK_LIST = 'GET_FEED_BACK_LIST';
export const SET_HOST_CURRENT_POSITION = 'SET_HOST_CURRENT_POSITION';
export const PUNCH_RECEIVABLE = 'PUNCH_RECEIVABLE';
export const SET_HOST_PUNCH_MAP = 'SET_HOST_PUNCH_MAP';

export const QUERY_PICK_ORDER_LIST = 'QUERY_PICK_ORDER_LIST';
export const CANCEL_PICK_ORDER = 'CANCEL_PICK_ORDER';
export const SAVE_PICK_ORDER = 'SAVE_PICK_ORDER';
export const SHIP_ORDER = 'SHIP_ORDER';
export const FORCE_CANCEL_PICK_ORDER = 'FORCE_CANCEL_PICK_ORDER';
export const PREVIEW_BATCH_SHIPMENT_PDF = 'PREVIEW_BATCH_SHIPMENT_PDF';
export const BATCH_PRINT_RECOMMEND_PRODUCT_PDF =
    'BATCH_PRINT_RECOMMEND_PRODUCT_PDF';
export const BATCH_PRINT_PICK_ORDER_PREVIEW_PDF =
    'BATCH_PRINT_PICK_ORDER_PREVIEW_PDF';
export const GET_PICK_ORDER_MESSAGE_LIST = 'GET_PICK_ORDER_MESSAGE_LIST';
export const ON_KEY_READ_MESSAGE = 'ON_KEY_READ_MESSAGE';
export const UPDATE_F1_ORDER_LIST = 'UPDATE_F1_ORDER_LIST';
export const UPDATE_F1_PACKAGE_ON_THE_GO_LIST =
    'UPDATE_F1_PACKAGE_ON_THE_GO_LIST';
export const VIEW_ON_THE_GO_PACKAGE = 'VIEW_ON_THE_GO_PACKAGE';
export const F1_ORDER_TAB_ACTIVE = 'F1_ORDER_TAB_ACTIVE';
export const GET_GAO_MAP_LOCATION = 'GET_GAO_MAP_LOCATION';
export const SET_SHIPMENTS_SOURCE = 'SET_SHIPMENTS_SOURCE';
export const UPDATE_CURRENT_PAGE_NUM = 'UPDATE_CURRENT_PAGE_NUM';
export const SET_F1_ORDER_SOURCE = 'SET_F1_ORDER_SOURCE';
export const UPDATE_F1_ORDER_CURRENT_PAGE_NUM =
    'UPDATE_F1_ORDER_CURRENT_PAGE_NUM';
export const SET_F1_ORDER_ON_GO_PACKAGE_SOURCE =
    'SET_F1_ORDER_ON_GO_PACKAGE_SOURCE';
export const UPDATE_F1_ORDER_ON_GO_PACKAGE_CURRENT_PAGE_NUM =
    'UPDATE_F1_ORDER_ON_GO_PACKAGE_CURRENT_PAGE_NUM';
export const ENTER_SALES_DELIVER_DETAIL = 'ENTER_SALES_DELIVER_DETAIL';
export const SET_PUNCH_STATUS = 'SET_PUNCH_STATUS';
export const SET_ORDER_RELATED_TASK_FLAG = 'SET_ORDER_RELATED_TASK_FLAG';
export const SET_CURRENT_SHIPMENT_ID = 'SET_CURRENT_SHIPMENT_ID';
export const UPDATE_SHIPMENT_LIST = 'UPDATE_SHIPMENT_LIST';
export const SET_REVOKE_PACKAGE = 'SET_REVOKE_PACKAGE';

export const YOUR_MESSAGE_TAB_ACTIVE = 'YOUR_MESSAGE_TAB_ACTIVE';
export const UPDATE_YOUR_MESSAGE_LIST = 'UPDATE_YOUR_MESSAGE_LIST';

export const B2B_CASMART_SHIPMENT = 'B2B_CASMART_SHIPMENT';

export const UPDATE_SHIPMENTORORDERDETAIL = 'UPDATE_SHIPMENTORORDERDETAIL';

export const UPDATE_SHIPMENT_LIST_TAB = 'UPDATE_SHIPMENT_LIST_TAB';

export const UPDATE_F1_ONGO_PACKAGE_SORT = 'UPDATE_F1_ONGO_PACKAGE_SORT';

export const SET_CURRENT_ST_NUMBER = 'SET_CURRENT_ST_NUMBER';

export const GET_F1_MESSAGE_LIST = 'GET_F1_MESSAGE_LIST';

export const CLEARE_F1_PACKAGE_DATA = 'CLEARE_F1_PACKAGE_DATA';
export const GET_RECEIVING_CODE = 'GET_RECEIVING_CODE';

export const PREVIEW_PROXY_DELIVERY_IMAGE = 'PREVIEW_PROXY_DELIVERY_IMAGE';

// Get order list
export const getOrderList = (data) => (dispatch) => {
    let tab = '';

    switch (data.tabFlag) {
        case 1:
            tab = 'tobeShip';
            break;
        case 2:
            tab = 'onHold';
            break;
        case 4:
            tab = 'complete';
            break;
        default:
    }

    if (data.pageNum === 1)
        dispatch({type: SHIPMENTLIST, payload: {pageNum: 1, data: [], tab}});
    const isCompletedOrderList = data.tabFlag === 4;
    const requestUrl = isCompletedOrderList
        ? completedOrderListUrl
        : hostOrderListUrl;
    const requestData = isCompletedOrderList
        ? {
              pageNum: data.pageNum,
              pageSize: data.pageSize,
              queryKey: data.queryKey,
          }
        : data;
    return dispatch(post(requestUrl, requestData)).then((res) => {
        res.tab = tab;
        dispatch({type: SHIPMENTLIST, payload: res});
        return res;
    });
};
// Update Shipment Search Fields
export const updateShipmentSearchFields = (params) => ({
    type: SHIPMENT_SEARCH_FIELD,
    payload: params,
});

export const updateF1OrderReceiveOrder = (params) => ({
    type: SAVE_F1ORDER_RECEIVE_ORDER,
    payload: params,
});

// Get shipment list
export const getShipmentList = (data) => (dispatch) => {
    if (data.pageNum === 1)
        dispatch({type: SHIPMENTLIST, payload: {pageNum: 1, data: []}});
    return dispatch(post(hostShipmentListUrl, data)).then((res) => {
        res.tab = 'receive';
        dispatch({type: SHIPMENTLIST, payload: res});
        return res;
    });
};
// On hold shipment
export const notShipOrder = (data) => post(shipmentHoldOrderUrl, data);
// On wait shipment
export const waitShipOrder = (data) => post(shipmentWaitOrderUrl, data);
// Cancel order
export const cancelOrder = (data) => post(cancelOrderUrl, data);
// Receive order
export const receiveOrder = (data) => post(receiveShipmentUrl, data);

// Get receive code
export const getReceiveCode = (data) => (dispatch) =>
    dispatch(post(getReceiveCodeUrl, data)).then((res) => {
        dispatch({type: GET_RECEIVING_CODE, payload: res});
        return res;
    });
// Ship shipment
export const shipmentShip = (data) => post(shipmentShipUrl, data);
// Check order status
export const checkOrderStatus = (params) => get(checkOrderStatusUrl, params);
//Cancel package
export const cancelPackage = (params) => get(cancelPackageUrl, params);
// Get F1 orders
export const getF1OrderList = (data) => (dispatch) =>
    dispatch(post(f1OrderListUrl, data)).then((res) => {
        dispatch({type: F1ORDERLIST, payload: res});
        return res;
    });

// Get F1 orders
export const getF1PackageOnTheGoList = (data) => (dispatch) =>
    dispatch(post(getF1PackageOnTheGoListUrl, data)).then((res) => {
        dispatch({type: F1_PACKAGE_ON_THE_GO_ORDERLIST, payload: res});
        return res;
    });

// Get F1 orders
export const viewOrderTracking = (data) => (dispatch) =>
    dispatch(post(viewOrderTrackingUrl, data)).then((res) => {
        dispatch({type: VIEW_ORDER_TRACKING, payload: res});
        return res;
    });

export const refreshF1OrderList = (id) => (dispatch) =>
    dispatch(get(`${f1OrderListRefreshUrl}?id=${id}`)).then((res) => {
        dispatch({type: F1_ORDER_LIST_REFRESH, payload: res});
        return res;
    });

// Update F1 Order Search Fields
export const updateF1OrderSearchFields = (params) => ({
    type: F1ORDER_SEARCH_FIELD,
    payload: params,
});

export const updateF1OrderSearchList = (params) => ({
    type: UPDATEF1ORDERSEARCHLIST,
    payload: params,
});

export const updateF1OrderReceiveSearchList = (params) => ({
    type: F1ORDER_RECEIVE_SEARCH_FIELD,
    payload: params,
});

export const updateF1OrderDetails = (params) => ({
    type: F1ORDER_RECEIVE_DETAIL,
    payload: params,
});

// Search F1 orders.
export const getF1OrderSearchList = (data) => (dispatch) =>
    dispatch(post(f1OrderListUrl, data)).then((res) => {
        dispatch({type: F1ORDERSEARCHLIST, payload: res});
        return res;
    });
// Get F1 order details
export const getF1OrderDetails = (params) => (dispatch) => {
    dispatch({type: F1ORDERDETAILS, payload: {}});
    return dispatch(get(f1OrderDetailsUrl, params)).then((res) => {
        dispatch({type: F1ORDERDETAILS, payload: res.data});
        return res;
    });
};

// Update f1Order list Search Fields
export const updateF1OrderListSearchFields = (params) => ({
    type: F1_ORDERLIST_SEARCH_FIELD,
    payload: params,
});

export const updateF1OrderList = (params) => ({
    type: UPDATE_F1_ORDER_LIST,
    payload: params,
});

export const updateF1PackageOnTheGoList = (params) => ({
    type: UPDATE_F1_PACKAGE_ON_THE_GO_LIST,
    payload: params,
});

//F1 order receive
export const getAllSkuConditionList = (data) =>
    post(getAllSkuConditionUrl, data);

// F1 order receive.
export const productsReceive = (data) => post(f1OrderReceiveUrl, data);
// Update shipment receive image
export const updateShipment = (data) => post(updateShipmentUrl, data);
// Update shipment other images
export const updateOtherImages = (data) => post(updateOtherImagesUrl, data);
// Delete shipment attachment by modeId and fileKey
export const deleteShipmentAttachment = (params) =>
    get(deleteShipmentAttachmentUrl, params);
// Upload shipment receive image
export const uploadReceiveImage = (data) => uploadFile(uploadFileUrl, data);
// Get invoice pdf url.
export const createInvoicePdf = (params) =>
    get(createInvoicePdfUrl, {shipmentId: params.id});

export const createInvoiceMorePdf = (params) =>
    get(printDispatchPdfsUrl, {shipmentIds: params.id});

export function previewBatchShipmentPdf(params, pdfName) {
    return (dispatch) => {
        const body = {shipmentIds: params.id};

        dispatch({type: PREVIEW_BATCH_SHIPMENT_PDF, payload: {}});

        return downloadPdfFile(printDispatchPdfsUrl, body, 'shipment')
            .then((res) => {
                dispatch({type: PREVIEW_BATCH_SHIPMENT_PDF, payload: res});
            })
            .catch(() => {
                dispatch({type: PREVIEW_BATCH_SHIPMENT_PDF, payload: {}});
            });
    };
}

export function batchRecommendProductPdf(params, pdfName) {
    return (dispatch) => {
        const body = {orderIds: params.id};

        dispatch({type: BATCH_PRINT_RECOMMEND_PRODUCT_PDF, payload: {}});

        return downloadPdfFile(batchRecommendPdfsUrl, body, 'recommend')
            .then((res) => {
                dispatch({
                    type: BATCH_PRINT_RECOMMEND_PRODUCT_PDF,
                    payload: res,
                });
            })
            .catch(() => {
                dispatch({
                    type: BATCH_PRINT_RECOMMEND_PRODUCT_PDF,
                    payload: {},
                });
            });
    };
}

export function batchPickOrderPreviewPdf(params, pdfName) {
    return (dispatch) => {
        const body = params;

        dispatch({type: BATCH_PRINT_PICK_ORDER_PREVIEW_PDF, payload: {}});

        return downloadPickOrderFile(pickOrderPreviewPdfsUrl, body, 'pickOrder')
            .then((res) => {
                dispatch({
                    type: BATCH_PRINT_PICK_ORDER_PREVIEW_PDF,
                    payload: res,
                });
            })
            .catch(() => {
                dispatch({
                    type: BATCH_PRINT_PICK_ORDER_PREVIEW_PDF,
                    payload: {},
                });
            });
    };
}

// export function previewTagUploadImage(params, fileName) {
//     return (dispatch) => {
//         const body = params;

//         dispatch({type: PREVIEW_ADVENT_IMAGE, payload: {}});

//         return downloadFile(previewTagUploadUrl, body, fileName)
//             .then((res) => {
//                 dispatch({type: PREVIEW_ADVENT_IMAGE, payload: res});
//             })
//             .catch(() => {
//                 dispatch({type: PREVIEW_ADVENT_IMAGE, payload: {}});
//             });
//     };
// }

// Get order details.
export const getOrderDetails = (params) => (dispatch) => {
    dispatch({type: SHIPMENTORORDERDETAILS, payload: {}});
    return dispatch(get(myOrderDetailUrl, params)).then((res) => {
        dispatch({type: SHIPMENTORORDERDETAILS, payload: res.data});
        return res;
    });
};
export const hostDeliverToShip = (params) => (dispatch) => {
    dispatch({type: SHIPMENTORORDERDETAILS, payload: {}});
    return dispatch(get(hostDeliverToShipUrl, params)).then((res) => {
        dispatch({type: SHIPMENTORORDERDETAILS, payload: res.data});
        return res;
    });
};

export const getSkuInventoryDetails = (params) => (dispatch) => {
    dispatch({type: SKU_INVENTORY_DETAILS, payload: {}});
    return dispatch(get(getSKUInventoryDetailUrl, params)).then((res) => {
        dispatch({type: SKU_INVENTORY_DETAILS, payload: res.data});
        return res;
    });
};

export const getHostShipmentDetails = (params) => (dispatch) =>
    dispatch(get(hostShipmentDetailUrl, params));

/**
 * Abnormal Record
 */
// Send To Backend Request abnormalRecord list
export const getAbnormalRecordList = (params) => (dispatch) => {
    if (params.pageNum === 1)
        dispatch({type: ABNORMALRECORDLIST, payload: {pageNum: 1, data: []}});
    return dispatch(post(abnormalRecordListUrl, params)).then((res) => {
        dispatch({type: ABNORMALRECORDLIST, payload: res});
        return res;
    });
};

export const saveAbnormalRecord = (params) =>
    post(saveAbnormalRecordUrl, params);

export const getSkuReplenishmentDetails = (data) => (dispatch) =>
    dispatch(post(getSkuReplenishmentDetailsUrl, data)).then((res) => {
        dispatch({type: SKU_REPLENISHMENT_DETAILS, payload: res});
        return res;
    });

// Get Recommend pdf url.
export const createRecommendPdf = (params) =>
    get(createRecommendPdfUrl, {orderId: params});

// Update tracking number
export const updateTrackingNumber = (data) =>
    post(shipmentUpdateTrackNumberUrl, data);

export const getShipmentDocumentCoa = (data) => (dispatch) =>
    dispatch(post(shipmentDocumentCoaUrl, data));

export const getShipmentProxyPdf = (data) => () =>
    downloadPickOrderFile(shipmentProxyPdfUrl, data, 'shipmentProxyPdf');

export const sendShipmentNotification = (data) => (dispatch) =>
    dispatch(post(shipmentNotificationSendUrl, data));

export const checkShipmentCoaApplication = (data) => (dispatch) =>
    dispatch(post(shipmentNotificationCheckUrl, data));

// Get F1 shipment view data
export const getF1ShipmentViewData = (params) => (dispatch) => {
    dispatch({type: F1_SHIPMENT_VIEW_DATA, payload: {}});
    return dispatch(get(f1ShipmentViewUrl, params)).then((res) => {
        dispatch({type: F1_SHIPMENT_VIEW_DATA, payload: res.data});
        return res;
    });
};

// Get F1 shipment wait receive
export const getF1ShipmentWaitReceive = (params) => (dispatch) => {
    dispatch({type: INTERNAL_RECEIVED_GOOD, payload: {}});
    return dispatch(get(f1ShipmentWaitReceivelUrl, params)).then((res) => {
        dispatch({type: INTERNAL_RECEIVED_GOOD, payload: res.data});
        return res;
    });
};

// View f1 on the go package receive
export const viewOnTheGoPackage = (data) => (dispatch) =>
    dispatch(post(viewOnTheGoPackageUrl, data)).then((res) => {
        dispatch({type: VIEW_ON_THE_GO_PACKAGE, payload: res});
        return res;
    });

// Get F1 shipment wait shipped
export const getF1ShipmentWaitShipped = (params) => (dispatch) => {
    dispatch({type: F1_SHIPMENT_WAIT_SHIP, payload: {}});
    return dispatch(get(f1ShipmentWaitShipUrl, params)).then((res) => {
        dispatch({type: F1_SHIPMENT_WAIT_SHIP, payload: res.data});
        return res;
    });
};

// Get F1 shipment received
export const getF1ShipmentReceived = (params) => (dispatch) => {
    dispatch({type: F1_SHIPMENT_RECEIVED, payload: {}});
    return dispatch(get(f1ShipmentReceivedUrl, params)).then((res) => {
        dispatch({type: F1_SHIPMENT_RECEIVED, payload: res.data});
        return res;
    });
};
export const f1ReceivePackage = (data) => post(f1ShipmentReceiveUrl, data);

export const getUserCenterAdventQuantity = () => (dispatch) => {
    dispatch({type: GET_USER_CENTER_ADVENT_QUANTITY, payload: {}});
    return dispatch(get(userCenterAdventQuantityUrl)).then((res) => {
        dispatch({type: GET_USER_CENTER_ADVENT_QUANTITY, payload: res.data});
        return res;
    });
};

export const getAdventProductOfSCList = () => (dispatch) => {
    dispatch({type: GET_ADVENT_PRODUCT_SC_LIST, payload: {}});
    return dispatch(get(adventProductOfSCListUrl)).then((res) => {
        dispatch({type: GET_ADVENT_PRODUCT_SC_LIST, payload: res.data});
        return res.data;
    });
};

export const getAdventInventorDetail = (params) => (dispatch) => {
    dispatch({type: ADD_ADVENT_INVENTORY_DETAIL, payload: {}});
    return dispatch(get(addAdventInventorDetailUrl, params)).then((res) => {
        dispatch({type: ADD_ADVENT_INVENTORY_DETAIL, payload: res.data});
        return res;
    });
};

export const uploadTagOfAdventProduct = (params) => post(tagUploadUrl, params);

// export const previewTagUploadImage = (params, fileName) => downloadFile(previewTagUploadUrl, params, fileName);

export function previewTagUploadImage(params, fileName) {
    return (dispatch) => {
        const body = params;

        dispatch({type: PREVIEW_ADVENT_IMAGE, payload: {}});

        return downloadFile(previewTagUploadUrl, body, fileName)
            .then((res) => {
                dispatch({type: PREVIEW_ADVENT_IMAGE, payload: res});
            })
            .catch(() => {
                dispatch({type: PREVIEW_ADVENT_IMAGE, payload: {}});
            });
    };
}

export function previewProxyDeliveryUploadImage(params, fileName) {
    return (dispatch) => {
        const body = params;

        dispatch({type: PREVIEW_PROXY_DELIVERY_IMAGE, payload: {}});

        return downloadProxyDeliverFile(previewTagUploadUrl, body, fileName)
            .then((res) => {
                dispatch({type: PREVIEW_PROXY_DELIVERY_IMAGE, payload: res});
            })
            .catch(() => {
                dispatch({type: PREVIEW_PROXY_DELIVERY_IMAGE, payload: {}});
            });
    };
}

export const getDeliverDetails = (params) => (dispatch) => {
    dispatch({type: GET_DELIVER_DETAILS, payload: {}});
    return dispatch(get(deliverDetailUrl, params)).then((res) => {
        dispatch({type: GET_DELIVER_DETAILS, payload: res.data});
        return res;
    });
};

// Update F1 Order Search Fields
export const enterSalesDeliverDetail = (params) => ({
    type: ENTER_SALES_DELIVER_DETAIL,
    payload: params,
});

// get shipment package quantity
export const getShipmentPackageQuantity = (data) => (dispatch) => {
    dispatch(get(shipmentPackageQuantityUrl, data)).then((res) => {
        dispatch({type: GET_SHIPPED_PACKAGE_QUANTITY, payload: res});
        return res;
    });
};

export function scrapUpload(params) {
    const url = `${scrapUploadUrl}?id=${params.id}&path=${params.path}`;
    const options = {
        method: 'GET',
    };

    const request = () => ({type: SCRAP_UPLOAD, payload: {}});
    const success = (response) => {
        return {type: SCRAP_UPLOAD, payload: response};
    };
    const failure = () => ({type: SCRAP_UPLOAD, payload: {}});

    return callApi(url, options, request, success, failure);
}

export function getSupplyCenterList() {
    const options = {
        method: 'GET',
    };

    const request = () => ({
        type: SUPPLY_CENTER,
        payload: {supplyCenterlist: {}},
    });
    const success = (response) => {
        let data = response['data'];
        data.map((item) => {
            item['fullName'] = item['name'];
            delete item['name'];
        });
        return {type: SUPPLY_CENTER, payload: response['data']};
    };
    const failure = () => ({
        type: SUPPLY_CENTER,
        payload: {supplyCenterlist: {}},
    });

    return callApi(supplyCenterListUrl, options, request, success, failure);
}

// Get SC list
export function getAllSCList(params) {
    const request = () => ({
        type: ALL_SC_LIST,
        payload: {supplyCenterAlllist: {}},
    });

    const options = {
        method: 'GET',
    };

    const success = (response) => {
        let data = response['data'];
        data.map((item) => {
            item['fullName'] = item['value'];
            item['id'] = item['key'];
            delete item['value'];
            delete item['key'];
        });
        return {type: ALL_SC_LIST, payload: response['data']};
    };
    const failure = () => ({
        type: SUPPLY_CENTER,
        payload: {supplyCenterAlllist: {}},
    });

    return callApi(getAllSCListUrl, options, request, success, failure);
}

export function getVagueSearchList(params) {
    const url = `${skuVagueSearch}?scId=${params.scId}&queryKey=${params.queryKey}`;
    const options = {
        method: 'GET',
    };

    const request = () => ({
        type: SKU_VAGUE_SEARCH,
        payload: {skuVagueSearchData: {}},
    });
    const success = (response) => {
        return {type: SKU_VAGUE_SEARCH, payload: response['data']};
    };
    const failure = () => ({
        type: SKU_VAGUE_SEARCH,
        payload: {skuVagueSearchData: {}},
    });

    return callApi(url, options, request, success, failure);
}

//Internal order transfer list
export const getInternalOrderList = (data) => (dispatch) =>
    dispatch(post(internalOrderQueryUrl, data)).then((res) => {
        let tab = data.inOrOut;
        res.tab = tab;
        dispatch({type: GET_INTERNAL_ORDER_LIST, payload: res});
        return res;
    });

//Internal order transfer kit list
export const getInternalOrderKitList = (data) => (dispatch) =>
    dispatch(post(internalOrderQueryKitUrl, data)).then((res) => {
        dispatch({type: GET_INTERNAL_ORDER_KIT_LIST, payload: res});
        return res;
    });

//Internal order transfer add orderNo
export const submitAddOrderNo = (data) => (dispatch) =>
    dispatch(post(internalAddOrderNoUrl, data)).then((res) => {
        dispatch({type: INTERNAL_ADD_ORDER_NO, payload: res});
        return res;
    });

//Internal order transfer withdraw
export const submitWithdraw = (id) => (dispatch) =>
    dispatch(get(`${internalWithdrawUrl}?orderId=${id}`)).then((res) => {
        dispatch({type: INTERNAL_WITHDRAW, payload: res});
        return res;
    });

//Internal order transfer update
export const submitUpdate = (data) => (dispatch) =>
    dispatch(post(internalUpdatedOrderNoUrl, data)).then((res) => {
        dispatch({type: INTERNAL_UPDATE_NO, payload: res});
        return res;
    });

//Internal order transfer Received
export const receivedGoods = (id) => (dispatch) =>
    dispatch(get(`${internalReceivedGoodUrl}?orderId=${id}`)).then((res) => {
        dispatch({type: INTERNAL_RECEIVED_GOOD, payload: res});
        return res;
    });

// red quantity
export const internalRedQuantity = () => (dispatch) =>
    dispatch(get(internalRedQuantityUrl)).then((res) => {
        dispatch({type: INTERNAL_REDQUANTITY, payload: res});
        return res;
    });

export const updateInternalTransferSearchList = (params) => ({
    type: INTERNAL_TRANSFER_SEARCH_FIELD,
    payload: params,
});

//Apply internal order transfer
export const applyInternalOrderTransfer = (params) =>
    post(internalOrderTransferApplyUrl, params);

export const getInternalOrderScHostAddress = (params) => (dispatch) => {
    dispatch({type: GET_INTERNAL_ORDER_SC_HOST_ADDRESS, payload: {}});
    return dispatch(get(getInternalOrderScHostAddressUrl, params)).then(
        (res) => {
            dispatch({
                type: GET_INTERNAL_ORDER_SC_HOST_ADDRESS,
                payload: res.data,
            });
            return res;
        },
    );
};

export const getInternalOrderDetail = (params) => (dispatch) => {
    dispatch({type: UPDAE_INTERNAL_ORDER_STATUS, payload: 'SHIPPED'});
    return dispatch(get(internalOrderDetailUrl, params)).then((res) => {
        dispatch({type: GET_INTERNAL_ORDER_DETAIL, payload: res.data});
        return res;
    });
};

//Internal order sku kit list
export const getSkuKitListOfInternalOrder = (data) => (dispatch) =>
    dispatch(post(getSkuKitListOfInternalOrderUrl, data)).then((res) => {
        dispatch({type: GET_SKU_KIT_LIST_OF_INTERNAL_ORDER, payload: res});
        return res;
    });

//Internal order sku kit list
export const getLotQuantityOfInternalOrder = (data) => (dispatch) =>
    dispatch(post(getLotQuantityOfInternalOrderUrl, data)).then((res) => {
        dispatch({type: GET_LOT_QUANTITY_OF_INTERNAL_ORDER, payload: res});
        return res;
    });

export const updateInternalOrderStatus = (params) => (dispatch) => {
    dispatch({type: UPDAE_INTERNAL_ORDER_STATUS, payload: 'UPDATING'});
    switch (params.actionType) {
        case 'RECEIVE':
            return dispatch(get(updateShipStatusUrl, params))
                .then((res) => {
                    let payload = '';
                    if (res.status === 'success') {
                        payload = 'RECEIVED';
                    } else {
                        payload = 'RECEIVE_FAILED';
                    }
                    dispatch({type: UPDAE_INTERNAL_ORDER_STATUS, payload});
                    return res;
                })
                .catch(() => {
                    dispatch({
                        type: UPDAE_INTERNAL_ORDER_STATUS,
                        payload: 'RECEIVE_FAILED',
                    });
                });
        case 'REVERT':
            return dispatch(get(internalWithdrawUrl, {orderId: params.orderId}))
                .then((res) => {
                    let payload = '';
                    if (res.status === 'success') {
                        payload = 'REVERTED';
                    } else {
                        payload = 'REVERT_FAILED';
                    }
                    dispatch({type: UPDAE_INTERNAL_ORDER_STATUS, payload});
                    return res;
                })
                .catch(() => {
                    dispatch({
                        type: UPDAE_INTERNAL_ORDER_STATUS,
                        payload: 'REVERT_FAILED',
                    });
                });
        default:
            break;
    }
};

export const getOrderDetailMessageCount = (data) => (dispatch) =>
    dispatch(post(getOrderDetailMessageCountUrl, data)).then((res) => {
        dispatch({type: ORDER_DETAIL_MESSAGE_COUNT, payload: res});
        return res;
    });
export const getOrderDetailMessageList = (data) => (dispatch) =>
    dispatch(post(getOrderDetailMessageListUrl, data)).then((res) => {
        dispatch({type: ORDER_DETAIL_MESSAGE_LIST, payload: res});
        return res;
    });
export const getOrderDetailOneKeyRead = (data) => (dispatch) =>
    dispatch(post(getOrderDetailOneKeyReadUrl, data)).then((res) => {
        dispatch({type: ORDER_DETAIL_ON_KEY_READ, payload: res});
        return res;
    });

export const getMsgTotal = (data) => (dispatch) =>
    dispatch(post(getYourMsgTotalUrl, data)).then((res) => {
        dispatch({type: YOUR_MESSAGE_TOTAL, payload: res});
        return res;
    });

export const getYourMassageList = (data) => (dispatch) =>
    dispatch(post(getYourMsgListUrl, data)).then((res) => {
        dispatch({type: YOUR_MESSAGE_LIST, payload: res});
        return res;
    });

export const yourMassageRead = (id) => (dispatch) =>
    dispatch(get(`${signReadUrl}?messageId=${id}`)).then((res) => {
        dispatch({type: YOUR_MESSAGE_READ, payload: res});
        return res;
    });

//get Scrap Type
export function getScrapType() {
    const options = {
        method: 'GET',
    };

    const request = () => ({
        type: GET_SCRAP_TYPE,
        payload: {scrapType: {}},
    });
    const success = (response) => {
        let data = response['data'];
        data.map((item) => {
            item['fullName'] = item['value'];
            delete item['value'];
        });
        return {type: GET_SCRAP_TYPE, payload: response['data']};
    };
    const failure = () => ({
        type: GET_SCRAP_TYPE,
        payload: {scrapType: {}},
    });

    return callApi(getScrapTypeUrl, options, request, success, failure);
}

export function checkF1Number(params) {
    const options = {
        method: 'POST',
        data: params,
    };

    const request = () => ({
        type: CHECK_F1_NUMBER,
        payload: {expressNumberList: {}},
    });
    const success = (response) => {
        let data = response['data'];
        data &&
            data.length > 0 &&
            data.map((item, index) => {
                data[index] = {fullName: item, id: item};
            });
        return {type: CHECK_F1_NUMBER, payload: data};
    };
    const failure = () => ({
        type: CHECK_F1_NUMBER,
        payload: {expressNumberList: {}},
    });

    return callApi(checkF1NumberUrl, options, request, success, failure);
}

export function e1GetSkuList(params) {
    const options = {
        method: 'POST',
        data: params,
    };

    const request = () => ({
        type: E1_GET_SKU_LIST,
        payload: {scrapSkuList: {}},
    });
    const success = (response) => {
        let data = response.data;
        data &&
            data.length > 0 &&
            data.map((item) => {
                item.fullName = item.displaySku;
            });
        return {type: E1_GET_SKU_LIST, payload: data};
    };
    const failure = () => ({
        type: E1_GET_SKU_LIST,
        payload: {scrapSkuList: {}},
    });

    return callApi(e1GetSkuListUrl, options, request, success, failure);
}

export function getScrapParams(params) {
    const options = {
        method: 'POST',
        data: params,
    };

    const request = () => ({
        type: GET_SCRAP_PARAMS,
        payload: {scrapParamsList: {}},
    });
    const success = (response) => {
        let data = response.data;
        data &&
            data.length > 0 &&
            data.map((item) => {
                item.fullName = item.lot;
            });
        return {type: GET_SCRAP_PARAMS, payload: data};
    };
    const failure = () => ({
        type: GET_SCRAP_PARAMS,
        payload: {scrapParamsList: {}},
    });

    return callApi(getScrapParamsUrl, options, request, success, failure);
}

export const queryPickOrderList = (params) => (dispatch) => {
    dispatch({type: QUERY_PICK_ORDER_LIST, payload: {}});
    return dispatch(post(queryPickOrderListUrl, params)).then((res) => {
        dispatch({type: QUERY_PICK_ORDER_LIST, payload: res.data});
        return res;
    });
};

export const cancelPickOrder = (params) => (dispatch) => {
    dispatch({type: CANCEL_PICK_ORDER, payload: {}});
    return dispatch(post(cancelPickOrderUrl, params)).then((res) => {
        dispatch({type: CANCEL_PICK_ORDER, payload: res.data});
        return res;
    });
};

export const savePickOrder = (params) => post(savePickOrderUrl, params);

export const shipOrder = (params) => (dispatch) => {
    dispatch({type: SHIP_ORDER, payload: {}});
    return dispatch(post(shipOrderUrl, params)).then((res) => {
        dispatch({type: SHIP_ORDER, payload: res.data});
        return res;
    });
};

export const forceCancelPickOrder = (id) => (dispatch) =>
    dispatch(get(`${forceCancelUrl}?orderId=${id}`)).then((res) => {
        dispatch({type: FORCE_CANCEL_PICK_ORDER, payload: res});
        return res;
    });

export function getPickOrderMessageList(params) {
    const url = `${getPickOrderMessageUrl}?orderId=${params.id}`;
    const options = {
        method: 'GET',
    };

    const request = () => ({type: GET_PICK_ORDER_MESSAGE_LIST, payload: {}});
    const success = (response) => {
        return {type: GET_PICK_ORDER_MESSAGE_LIST, payload: response};
    };
    const failure = () => ({type: GET_PICK_ORDER_MESSAGE_LIST, payload: {}});

    return callApi(url, options, request, success, failure);
}

export const oneKeyReadMessage = (params) => (dispatch) => {
    dispatch({type: ON_KEY_READ_MESSAGE, payload: {}});
    return dispatch(post(messageOneKeyReadUrl, params)).then((res) => {
        dispatch({type: ON_KEY_READ_MESSAGE, payload: res.data});
        return res;
    });
};

// Update F1 Order Tab Active
export const updateYourMessageTabActive = (params) => ({
    type: YOUR_MESSAGE_TAB_ACTIVE,
    payload: params,
});

// Update F1 Order Tab Active
export const updateF1OrderTabActive = (params) => ({
    type: F1_ORDER_TAB_ACTIVE,
    payload: params,
});

// Update F1 Order Search Fields
export const setShipmentsSource = (params) => ({
    type: SET_SHIPMENTS_SOURCE,
    payload: params,
});

// Update Punch Success Status
export const setPunchSuccessStatus = (params) => ({
    type: SET_PUNCH_STATUS,
    payload: params,
});

// Update Punch Success Status
export const setOrderRelatedTaskStatus = (params) => ({
    type: SET_ORDER_RELATED_TASK_FLAG,
    payload: params,
});

// Update Punch Success Status
export const setRevokePackageSuccess = (params) => ({
    type: SET_REVOKE_PACKAGE,
    payload: params,
});

// Update F1 Order Search Fields
export const setCurrentShipmentId = (params) => ({
    type: SET_CURRENT_SHIPMENT_ID,
    payload: params,
});

// Update F1 Order Search Fields
export const setCurrentStNum = (params) => ({
    type: SET_CURRENT_ST_NUMBER,
    payload: params,
});

// Update F1 Order Search Fields
export const updateShipmentList = (params) => ({
    type: UPDATE_SHIPMENT_LIST,
    payload: params,
});

// Update F1 Order Search Fields
export const updateShipmentListPageNum = (params) => ({
    type: UPDATE_CURRENT_PAGE_NUM,
    payload: params,
});

// Update F1 Order Search Fields
export const setF1OrderSource = (params) => ({
    type: SET_F1_ORDER_SOURCE,
    payload: params,
});

// Update F1 Order Search Fields
export const updateF1OrderListPageNum = (params) => ({
    type: UPDATE_F1_ORDER_CURRENT_PAGE_NUM,
    payload: params,
});

// Update F1 Order Search Fields
export const setF1OrderOnGoPackageSource = (params) => ({
    type: SET_F1_ORDER_ON_GO_PACKAGE_SOURCE,
    payload: params,
});

// Update F1 Order Search Fields
export const updateF1OrderOnGoPackageListPageNum = (params) => ({
    type: UPDATE_F1_ORDER_ON_GO_PACKAGE_CURRENT_PAGE_NUM,
    payload: params,
});

// Update F1 Order Search Fields
export const updateF1OnGoPackageSort = (params) => ({
    type: UPDATE_F1_ONGO_PACKAGE_SORT,
    payload: params,
});

export const punchSave = (params) => post(punchSaveUrl, params);

export const feedbackSave = (params) => post(feedbackSaveUrl, params);

export const getFeedbackList = (id) => (dispatch) =>
    dispatch(get(`${feedbackListUrl}?orderId=${id}`)).then((res) => {
        dispatch({type: GET_FEED_BACK_LIST, payload: res.data});
        return res.data;
    });

export const punchReceivable = (id) => (dispatch) =>
    dispatch(get(`${punchReceivableUrl}?id=${id}`)).then((res) => {
        dispatch({type: PUNCH_RECEIVABLE, payload: res.data});
        return res;
    });

export const getSysDict = (dictType) => (dispatch) =>
    dispatch(get(sysDictUrl, {dictType})).then((res) => res);

// Set host current position
export const setHostCurrentPosition = (params) => ({
    type: SET_HOST_CURRENT_POSITION,
    payload: params,
});

// Set host punch map
export const setHostPunchMap = (params) => ({
    type: SET_HOST_PUNCH_MAP,
    payload: params,
});

export const updateYourMassageList = (params) => ({
    type: UPDATE_YOUR_MESSAGE_LIST,
    payload: params,
});

export const b2bCasmartShipment = (params) => (dispatch) =>
    dispatch(
        get(
            `${b2bCasmartShipmentUrl}?shipmentId=${params.shipmentId}&orderId=${params.orderId}`,
        ),
    ).then((res) => {
        dispatch({type: B2B_CASMART_SHIPMENT, payload: res.data});
        return res;
    });

// Update SHIPMENT ORDER DETAIL
export const updateShipmentOrderDetails = (params) => ({
    type: UPDATE_SHIPMENTORORDERDETAIL,
    payload: params,
});

// Update F1 Order Tab Active
export const updateShipmentListTabActive = (params) => ({
    type: UPDATE_SHIPMENT_LIST_TAB,
    payload: params,
});

export const getF1MessageList = (data) => (dispatch) =>
    dispatch(post(getF1MessageListUrl, data)).then((res) => {
        dispatch({type: GET_F1_MESSAGE_LIST, payload: res});
        return res;
    });

// Update F1 Order Tab Active
export const clearF1PackageData = (params) => ({
    type: CLEARE_F1_PACKAGE_DATA,
    payload: params,
});
